import React, { Suspense, lazy } from 'react'
import PlogsSection from '../HomePage/PlogsSection'


const HeroSectionComponents = lazy(() => import('../../components/Hero Section Components/HeroSectionComponents'))

export default function PlogPage() {
    return (
        <Suspense>
            <HeroSectionComponents />
            <PlogsSection />
        </Suspense>
    )
}
